import { FilterSelectOption } from "../../filters/filters.types";
import { exciseStampsRepo } from "./exciseStamps.repo";
import {
  AkciznaMarkicaKategorijaProzivoda,
  ExciseStampRequestListPayload,
  IInformacijeZaVracanjeMarkica,
  IKategorijeProizvodaProps,
  IKreiranjeZahtevaZaMarkicuPayload,
  IMaloProdajnaPayload,
  IPodaciOMarkamaProizvodaPayload,
  IPopuniIzvestajZaKafuIliAlkoholPayload,
  IZahtevMarkiceIdProps,
} from "./exciseStamps.types";

class ExciseStampsService {
  getInicijalniPodaciZaZahtevObveznika = () => {
    return exciseStampsRepo.getInicijalniPodaciZaZahtevObveznika();
  };

  postVracanjeDodatnihInformacijaZaKreiranjeZahteva = (
    payload: IInformacijeZaVracanjeMarkica
  ) => {
    return exciseStampsRepo.postVracanjeDodatnihInformacijaZaKreiranjeZahteva(
      payload
    );
  };

  postKreiranjeZahtevaZaMarkicu = (
    payload: IKreiranjeZahtevaZaMarkicuPayload
  ) => {
    return exciseStampsRepo.postKreiranjeZahtevaZaMarkicu(payload);
  };

  putIzmeniZahtevZaMarkicu = (payload: IKreiranjeZahtevaZaMarkicuPayload) => {
    return exciseStampsRepo.putIzmeniZahtevZaMarkicu(payload);
  };

  postSviZahteviZaMarkicu = (payload: ExciseStampRequestListPayload) => {
    return exciseStampsRepo.postSviZahteviZaMarkicu(payload);
  };

  postGenerisiZahtevZaMarkicuPdf = (payload: IZahtevMarkiceIdProps) => {
    return exciseStampsRepo.postGenerisiZahtevZaMarkicuPdf(payload);
  };

  postInformacijeNapravljenogZahtevaZaMarkicu = (
    payload: IZahtevMarkiceIdProps
  ) => {
    return exciseStampsRepo.postInformacijeNapravljenogZahtevaZaMarkicu(
      payload
    );
  };

  postPodaciOMarkamaProizvoda = (payload: IPodaciOMarkamaProizvodaPayload) => {
    return exciseStampsRepo.postPodaciOMarkamaProizvoda(payload);
  };

  postMaloprodajneCeneMarkiProizvoda = (payload: IMaloProdajnaPayload) => {
    return exciseStampsRepo.postMaloprodajneCeneMarkiProizvoda(payload);
  };

  createStampajPredracun = (id: number | null) => {
    return exciseStampsRepo.createStampajPredracun(id);
  };

  createPopuniIzvestajZaKafuIliAlkohol = (
    payload: IPopuniIzvestajZaKafuIliAlkoholPayload
  ) => {
    return exciseStampsRepo.createPopuniIzvestajZaKafuIliAlkohol(payload);
  };

  updateIzmeniIzvestajZaKafuIliAlkohol = (
    payload: IPopuniIzvestajZaKafuIliAlkoholPayload,
    id: number | null
  ) => {
    return exciseStampsRepo.updateIzmeniIzvestajZaKafuIliAlkohol(payload, id);
  };

  getOptions = (filters: FilterSelectOption[]) => {
    const newFilters = filters?.map((option: FilterSelectOption) => {
      return { label: option.name, value: option.id };
    });
    return newFilters;
  };

  getTipObveznikaOptions = (
    id: number | null,
    state: IKategorijeProizvodaProps[]
  ) => {
    const options = state.find(
      (options) => options.idKategorijeProizvoda === id
    );
    return options?.tipObveznika.map((option) => {
      return { label: option.imeTipaObveznika, value: option.tipObveznikaId };
    });
  };

  getListaKategorijaZaZahtev = (
    brojZahteva: string,
    markicaKategorijeId: AkciznaMarkicaKategorijaProzivoda | null
  ) => {
    return exciseStampsRepo.getListaKategorijaZaZahtev(
      brojZahteva,
      markicaKategorijeId
    );
  };

  getMarkicaZahtevIsporuceniOpsezi = (
    brojZahteva: string,
    markicaKategorijeId: AkciznaMarkicaKategorijaProzivoda | null
  ) => {
    return exciseStampsRepo.getMarkicaZahtevIsporuceniOpsezi(
      brojZahteva,
      markicaKategorijeId
    );
  };

  getEvidencijaPeriodicniIzvestaji = () => {
    return exciseStampsRepo.getEvidencijaPeriodicniIzvestaji();
  };

  downloadDocumentSpecification = ({ documentId }: { documentId: number }) => {
    return exciseStampsRepo.downloadDocumentSpecification({ documentId });
  };
}

export const exciseStampsService = new ExciseStampsService();
